import React from "react"
import CategoryCirceBox from "./CategoryCirceBox";


const CategoriesHorizontalList = ({ min, categories, onCategoryClick }) => {

  // Hide if there are few categories
  if (categories.length < min) {
    return null
  }

  return <div>{categories.map((category) => {
    return <CategoryCirceBox category={category}
                             onClick={onCategoryClick}
                             key={category.id}/>
  })}</div>
}

export default CategoriesHorizontalList;
